export const FETCH_LESSON_SUCCESS = 'FETCH_LESSON_SUCCESS';
export const FETCH_NUDGE_SUCCESS = 'FETCH_NUDGE_SUCCESS';